import React, { useContext, useEffect, useState } from "react";
import { Button, Fade, Stack } from "@mui/material";
import styles from "../../content/pages/homepage.module.css";
import TradingPartnerListReceive from "./TadingPartnerListReceive";
import { Box } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import { WidgetContext } from "src/contexts/WidgetContext";
import { isIOS, isAndroid } from "../../utils/platformUtils";
import { trackFeatureTimeSpent } from "src/utils/analyticsCapFirebase";
import { useAuth0 } from "@auth0/auth0-react";

function TradingPartnerList({
  onClose,
  userDataPlatform,
  leagueIdPlatform,
  rostersData,
  loadingRoster,
  setErrorMessages,
  setShouldPlayAudio,
  aiSettings,
  setIsPaymentOpen,
  setInitialPaymentView,
  enableCreditValidation,
  calculatorSettings,
  selectedModel,
  setSelectedModel,
  userSubscription,
  setUserSubscription,
  setIsBenchDrawerOpen,
  characterRef,
  leagueSelectorBoxRef,
  setThoughtsCommon,
  markSignThoughtsForDrawer,
  clearSignThoughtsDrawerSource,
  isCreditsAnimating,
  creditsBoxRef,
}) {
  // import function of WidgetContext
  const { isDrawerOpen, selectedPartner, setIsDrawerOpen, selectedTeamInfo } = useContext(WidgetContext);
  const { user } = useAuth0();
  // Track when drawer opens
  const [drawerOpenTime, setDrawerOpenTime] = useState<number | null>(null);

  // Expand/collapse toggle: false = collapsed to LeagueSelector top, true = full height
  const [isExpanded, setIsExpanded] = useState(false);
  // Measured height (px) from viewport bottom to top of LeagueSelector box
  const [collapsedHeight, setCollapsedHeight] = useState<string>("70px");
  // Keep drawer above Quan only while expanded (and while collapsing animation completes)
  const [isAboveQuan, setIsAboveQuan] = useState(false);

  // Measure collapsed height from the LeagueSelector box ref
  useEffect(() => {
    const measure = () => {
      if (!leagueSelectorBoxRef?.current) return;
      const rect = leagueSelectorBoxRef.current.getBoundingClientRect();
      const h = Math.max(window.innerHeight - rect.top, 100);
      setCollapsedHeight(`${h}px`);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [leagueSelectorBoxRef]);

  // Reset to collapsed each time the drawer is closed
  useEffect(() => {
    if (!isDrawerOpen) {
      setIsExpanded(false);
    }
  }, [isDrawerOpen]);

  // zIndex flow: raise immediately on expand; delay lowering until height transition ends
  useEffect(() => {
    if (isExpanded) {
      setIsAboveQuan(true);
      return;
    }
    const timeout = setTimeout(() => {
      setIsAboveQuan(false);
    }, 300);
    return () => clearTimeout(timeout);
  }, [isExpanded]);

  // Full height = current behavior (safe-area-aware)
  const expandedHeight =
    isIOS || isAndroid
      ? aiSettings.quan
        ? "calc(100svh - env(safe-area-inset-top))"
        : "calc(100svh - env(safe-area-inset-top) - 56px)"
      : !aiSettings.quan
        ? "calc(100vh - 56px)"
        : "100%";

  const drawerHeight = isExpanded ? expandedHeight : collapsedHeight;
  const drawerZIndex = isAboveQuan ? 1450 : 1200; // 1450 > Quan(1400) and < Help/Payment/AI(1500+)

  // Track drawer open time
  useEffect(() => {
    if (isDrawerOpen && !drawerOpenTime) {
      setDrawerOpenTime(Date.now());
    }
  }, [isDrawerOpen, drawerOpenTime]);

  const handleClose = () => {
    // Calculate time spent if drawer was open
    if (drawerOpenTime) {
      // Calculate time spent in milliseconds
      const timeSpentMs = Date.now() - drawerOpenTime;
      // Convert time spent to seconds
      const timeSpentSeconds = Math.round(timeSpentMs / 1000);

      // Get current platform/team info from context
      const currentlatform = selectedTeamInfo?.platformId || "unknown";
      const authId = user?.sub || "unknown";

      console.log("currentlatform TRADES", currentlatform);
      console.log("timeSpentSeconds TRADES", timeSpentSeconds, "seconds");

      // Track the time spent
      if (timeSpentSeconds > 0) {
        trackFeatureTimeSpent(authId, "trades", timeSpentSeconds, currentlatform);
      }

      // Reset timer
      setDrawerOpenTime(null);
    }

    // Sync close: onClose clears thoughts + closes drawer (avoids sign flash before clear)
    onClose();
  };

  // console.log("ROSTER DATA", rostersData);

  return (
    <>
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        // onClose={handleClose}
        // onOpen={() => setIsDrawerOpen(true)}
        hideBackdrop={true}
        sx={{
          pointerEvents: "none",
        }}
        ModalProps={{
          keepMounted: true,
          sx: {
            pointerEvents: "auto", // Block background scroll when drawer is open
            top: isIOS || isAndroid ? "calc(env(safe-area-inset-top) + 56px)" : "56px",
            zIndex: drawerZIndex,
          },
        }}
        PaperProps={{
          sx: {
            width: {
              xs: "100%",
              sm: "720px",
              md: "720px",
              lg: "720px",
            },
            margin: {
              xs: "0",
              sm: "0 auto",
              md: "0 auto",
              lg: "0 auto",
            },
            height: drawerHeight,
            transition: "height 0.3s ease-in-out",
            // height: "100%",
            border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          },
        }}
      >
        <Fade in={isDrawerOpen} timeout={700}>
          <Box
            sx={{
              bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`,
              // ADD THIS LINE to respect the bottom safe area on all devices
              paddingBottom: isAndroid ? "max(env(safe-area-inset-bottom), 15px)" : "0px",
              pointerEvents: "auto", // Add this - re-enables interaction inside the drawer
            }}
            className={styles.noScrollbar}
          >
            {selectedPartner && (
              <TradingPartnerListReceive
                onClose={handleClose}
                userDataPlatform={userDataPlatform}
                setErrorMessages={setErrorMessages}
                setIsBenchDrawerOpen={setIsBenchDrawerOpen}
                leagueIdPlatform={leagueIdPlatform}
                rostersData={rostersData}
                loadingRoster={loadingRoster}
                setShouldPlayAudio={setShouldPlayAudio}
                aiSettings={aiSettings}
                setIsPaymentOpen={setIsPaymentOpen}
                setInitialPaymentView={setInitialPaymentView}
                enableCreditValidation={enableCreditValidation}
                calculatorSettings={calculatorSettings}
                selectedModel={selectedModel}
                setSelectedModel={setSelectedModel}
                userSubscription={userSubscription}
                setUserSubscription={setUserSubscription}
                characterRef={characterRef}
                isExpanded={isExpanded}
                onToggleExpand={() => setIsExpanded((prev) => !prev)}
                setThoughtsCommon={setThoughtsCommon}
                markSignThoughtsForDrawer={markSignThoughtsForDrawer}
                clearSignThoughtsDrawerSource={clearSignThoughtsDrawerSource}
                isCreditsAnimating={isCreditsAnimating}
                creditsBoxRef={creditsBoxRef}
              />
            )}
          </Box>
        </Fade>
      </Drawer>
    </>
  );
}

export default TradingPartnerList;
